/**
 * Полноэкранный лоадер — по центру viewport (с учётом safe area).
 * Не скрывать, пока страница не загружена.
 */

interface PageLoaderProps {
  message?: string;
  /** Show heart icon instead of spinner */
  showHeart?: boolean;
}

/** Pulsing heart icon */
function PulsingHeart() {
  return (
    <div className="animate-pulse">
      <svg viewBox="0 0 48 48" className="w-16 h-16">
        <path
          d="M24 42c-1.5-1.5-4-3.5-7-6.5C11 30 4 23 4 15c0-6 5-11 11-11 3.5 0 6.5 1.5 9 4.5 2.5-3 5.5-4.5 9-4.5 6 0 11 5 11 11 0 8-7 15-13 20.5-3 3-5.5 5-7 6.5z"
          fill="#fbbf24"
        />
        <path
          d="M14 14c1.5-2 4-3 6-2"
          stroke="#fef3c7"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
          opacity="0.7"
        />
      </svg>
    </div>
  );
}

/** Minimal splash (logo only) for PWA/Mini App reload when tokens exist — no "Подключение..." text. */
export function SplashScreen() {
  return (
    <div
      className="fixed inset-0 z-[60] flex flex-col items-center justify-center bg-gradient-to-b from-amber-50/80 to-white/80 backdrop-blur-sm min-h-[100dvh]"
      style={{
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <PulsingHeart />
    </div>
  );
}

export function PageLoader({ message = "Загрузка...", showHeart = true }: PageLoaderProps) {
  return (
    <div
      className="fixed inset-0 z-[60] flex flex-col items-center justify-center bg-gradient-to-b from-amber-50/80 to-white/80 backdrop-blur-sm min-h-[100dvh]"
      style={{
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      {showHeart ? (
        <PulsingHeart />
      ) : (
        <div className="w-10 h-10 border-3 border-slate-200 border-t-amber-500 rounded-full animate-spin mb-4" />
      )}
      <p className="text-sm xs:text-base text-slate-600 font-medium mt-4">
        {message}
      </p>
    </div>
  );
}
